import nunjucks from 'nunjucks'

export type EmailTemplateContext = Record<string, string>

// Jinja-compatible engine configured like the backend's renderer: templates come from strings, and
// undefined variables render as empty instead of throwing so a half-filled form still previews.
const environment = new nunjucks.Environment(null, { autoescape: false, throwOnUndefined: false })

const escapeHtml = (text: string): string =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')

const render = (template: string, context: Record<string, string>): string => {
  try {
    return environment.renderString(template, context)
  } catch {
    return ''
  }
}

export const renderEmailSubject = (template: string, context: EmailTemplateContext): string => render(template, context)

// The template body is HTML (same contract as the backend's Jinja renderer): only the substituted
// values are escaped, the template markup passes through as-is.
export const renderEmailHtmlBody = (template: string, context: EmailTemplateContext): string => {
  const escapedContext = Object.fromEntries(Object.entries(context).map(([key, value]) => [key, escapeHtml(value).replace(/\n/g, '<br/>')]))
  return render(template, escapedContext)
}
